import React, { Context, createContext, PureComponent, ReactNode } from 'react';
import { fallbackLanguage, languages, userCountry, userLanguage } from '../../configs/env';
import { withErrorBoundary } from '../../error-handling/withErrorBoundary';
import { withTypo3, WithTypo3Props } from '../Typo3Provider/withTypo3';

// TODO: Evaluate: Deprecate as language doesn't change within an lifecycle? Language change will trigger full reload

interface LanguageProviderProps {
  children: ReactNode;
}

export interface LanguageContextApi {
  languageCode: string;
  countryCode: string;
  locale: string;
}

interface LanguageProviderState {
  codes: LanguageContextApi;
  languageUid: number;
}

type LanguageContextType = Context<LanguageContextApi>;

export const LanguageContext: LanguageContextType = createContext({
  languageCode: userLanguage,
  countryCode: userCountry,
  locale: `${userLanguage.toLowerCase()}-${userCountry.toUpperCase()}`
});

class LanguageProvider extends PureComponent<
  LanguageProviderProps & WithTypo3Props,
  LanguageProviderState
> {
  public static getDerivedStateFromProps(
    nextProps: LanguageProviderProps & WithTypo3Props,
    prevState: LanguageProviderState
  ): Partial<LanguageProviderState> | null {
    if (nextProps.typo3.languageUid !== prevState.languageUid) {
      const { languageUid } = nextProps.typo3;
      return {
        languageUid,
        codes: languages[languageUid] || fallbackLanguage
      };
    }
    return null;
  }

  public state: LanguageProviderState = {
    codes: languages[this.props.typo3.languageUid] || fallbackLanguage,
    languageUid: this.props.typo3.languageUid
  };

  public render() {
    const { children } = this.props;
    return (
      <LanguageContext.Provider value={this.state.codes}>
        {children}
      </LanguageContext.Provider>
    );
  }
}

export default withErrorBoundary(
  withTypo3(LanguageProvider),
  'LanguageProvider'
);
